"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateNotificationPresetRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class UpdateNotificationPresetRequestDto {}
exports.UpdateNotificationPresetRequestDto = UpdateNotificationPresetRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", String)], UpdateNotificationPresetRequestDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], UpdateNotificationPresetRequestDto.prototype, "enabled", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.NotificationPresetTrigger,
  required: false
}), __metadata("design:type", String)], UpdateNotificationPresetRequestDto.prototype, "trigger", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.NotificationPresetVariant,
  required: false
}), __metadata("design:type", String)], UpdateNotificationPresetRequestDto.prototype, "variant", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Number)], UpdateNotificationPresetRequestDto.prototype, "delayMinutes", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Number)], UpdateNotificationPresetRequestDto.prototype, "sortOrder", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Number)], UpdateNotificationPresetRequestDto.prototype, "priority", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.NotificationPresetVenuePresence,
  required: false
}), __metadata("design:type", String)], UpdateNotificationPresetRequestDto.prototype, "venuePresence", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", String)], UpdateNotificationPresetRequestDto.prototype, "messageTemplate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.NotificationType,
  required: false
}), __metadata("design:type", String)], UpdateNotificationPresetRequestDto.prototype, "notificationType", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UpdateNotificationPresetRequestDto.prototype, "minCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UpdateNotificationPresetRequestDto.prototype, "deepLinkTarget", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'When true, mobile may bypass the daily notification frequency cap for this preset.'
}), __metadata("design:type", Boolean)], UpdateNotificationPresetRequestDto.prototype, "exemptFromDailyFrequencyCap", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'When true, each send is written to server logs for debugging.'
}), __metadata("design:type", Boolean)], UpdateNotificationPresetRequestDto.prototype, "shouldLogSends", void 0);
//# sourceMappingURL=UpdateNotificationPresetRequest.dto.js.map